export default __webpack_public_path__ + "static/media/mobile_apiaries_image_en.ca1e303b.png";